<template>
  <div class="main-content-index">
    <!-- <wf-button v-if="userInfo.usertype === 7" class="business-btn" icon="icon iconfont iconicon_enlarge" v-permission="'系统设置'" @click="$router.push('/business')">添加业务板块</wf-button> -->
    <basiCcontainer v-loading="loading">
      <template #head>
        <wf-button class="business-btn" style="margin-right:20px;" v-permission="'项目管理-所有项目列表'" @click="$router.push('/projectSetting')" plain>项目管理</wf-button>
        <wf-button class="business-btn" icon="icon iconfont iconicon_enlarge" v-permission="'项目管理-新增业务板块'" @click="$router.push('/business')">添加业务板块</wf-button>
      </template>
      <div class="project-wrap" v-if="dataList.length > 0">
        <div class="block-box project-folder" v-for="(item) in dataList" :key="item.department_category_id">
          <div class="block-title-line">
            <span class="line" :style="{'background':Color()}"></span>
            {{ item.department_category_name }}
          </div>
          <div class="block-content" :data-item="item.isMore" :ref="'conten'">
            <div @click="projectListClick(innerItem,item.department_category_name)" class="project-list-box activeCardHover" v-for="innerItem in item.projectlist" :key="innerItem.project_list_id">
              <div class="project-list-box_top">
                <div class="left">项目数 {{innerItem.projectcount}}</div>
                <div class="task-msgcount-super" v-show="innerItem.msgcount > 0">
                  {{innerItem.msgcount}}
                </div>
              </div>
              <div class="project-list-box_content">
                <div class="project-folder-icon">
                  <i class="iconfont" :class="innerItem.icon" :style="{color: innerItem.icon_color}"></i>
                </div>
              </div>
              <div class="project-list-box_bottom">
                {{innerItem.project_list_title}}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="project-wrap-nothing" v-else-if="!loading">
        <nothing :config="{tip:'暂无业务，快去添加小业务',btnText:$permission('系统设置') ? '添加业务板块' : ''}" @button-click="$router.push('/business')"></nothing>
      </div>
    </basiCcontainer>
    <el-drawer custom-class="my-drawer" :wrapperClosable="false" :visible.sync="visibleAdd" :with-header="false" size="410px">
      <addProject v-if="visibleAdd" :visible.sync="visibleAdd" @success="addSuccess"></addProject>
    </el-drawer>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex';
import addProject from "./add.vue";
import bus from '@/bus'
export default {
  name: "project",
  components: {
    addProject,
  },
  data() {
    return {
      dataList: [],
      departmentList: {},
      visibleAdd: false,
      loading: false,
      editVisible: false
    };
  },
  created() {
    this.fetchProjectList();
  },
  computed: {
    ...mapState('layout/layout', {
      showHeader: state => state.showHeader
    }),
    ...mapGetters("layout/layout", ['userInfo']),
  },
  mounted() {
    bus.$on('addProject', this.add)
    bus.$on('showProjectAll', this.showProjectAll)
  },
  methods: {
    ...mapActions('project/project', ['getDepartmentProjectfolder']),
    Color() {
      this.r = Math.floor(Math.random() * 255);
      this.g = Math.floor(Math.random() * 255);
      this.b = Math.floor(Math.random() * 255);
      return 'rgba(' + this.r + ',' + this.g + ',' + this.b + ',1)';
    },
    fetchProjectList() {
      this.loading = true;
      this.getDepartmentProjectfolder().then(res => {
        this.loading = false;
        this.dataList = res.ProjectList || [];
        this.dataList.forEach(item => {
          this.departmentList[item.department_category_id] = item.department_category_name
        })
      }).catch(err => {
        this.loading = false;
      })
    },
    viewProject(itemData) {
      this.$router.push({
        path: "/task",
        query: {
          projectId: itemData.project_id,
          isTabShow: true
        }
      });
    },
    add() {
      this.visibleAdd = true;
    },
    addSuccess() {
      this.visibleAdd = false;
      this.fetchProjectList();
    },
    projectListClick(item, department_category_name) {
      this.$router.push({
        path: "/projectFolder",
        query: {
          project_depart_id: item.department_category_id,
          project_list_id: item.project_list_id,
          department_category_name,
          // project_depart_name: this.departmentList[item.department_category_id]
          project_depart_name: item.project_list_title

        }
      })
    },
    showProjectAll(active) {
      this.$router.push({
        path: "/projectall",
        query: {
          type: active
        }
      })
    }
  }
};
</script>

<style lang="scss">
.color1 {
  color: #75748e;
  margin-right: 10px;
}
.el-link--inner:hover .iconicon_enlarge,
.el-link--inner:hover .el-icon-menu {
  color: #509aff;
}
.main-content-index {
  // background-color: #f1f2f3;
  .search-box {
    border: 0 none;
    display: flex;
    justify-content: flex-end;
    padding: 6px 18px;
    margin-bottom: -20px;
    position: relative;
    z-index: 999;
  }

  .block-title-line {
    display: flex;
    height: 66px;
    align-items: center;
    padding-left: 24px;
  }
  position: relative;
  .business-btn {
    // position: absolute;
    // top: 24px;
    // right: 24px;
    // z-index: 9;
  }
  .project-wrap-nothing {
    height: 100%;
  }
  .line {
    width: 4px;
    height: 14px;
    border-radius: 4px;
    display: block;
    margin-right: 16px;
  }
  .project-wrap {
    width: 100%;
    flex: 1;
  }
  .project-wrap .block-content {
    flex-direction: row;
    flex-wrap: wrap;
    overflow: hidden;
    transition: all 0.3s;
    padding-bottom: 20px;
    padding-left: 8px;
  }
  .set-maxheight {
    max-height: 225px;
  }
  .project-wrap .block-box {
    width: 100%;
    border-right: none;
    height: auto;
    overflow: hidden;
    position: relative;
  }
  .no-project-txt {
    width: 100%;
    height: 100%;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .more-load {
    height: 40px;
    width: 100%;
    line-height: 40px;
    text-align: center;
    // background: linear-gradient(
    //   to bottom,
    //   rgba(255, 255, 255, 0.8),
    //   rgba(255, 255, 255, 1)
    // );
    // position: absolute;
    // bottom: 0;
    // left: 0;
    // right: 0;
    // z-index: 2;
    span {
      cursor: pointer;
      font-size: 12px;
      color: #2682ff;
      .iconicon_arrow_task {
        margin-left: 8px;
      }
    }
  }
  .project-folder .block-content {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    overflow: hidden;
    transition: all 0.3s;
    padding-bottom: 0;
  }
  .project-folder .block-content .project-list-box {
    box-sizing: border-box;
    position: relative;
    width: 224px;
    height: 154px;
    cursor: pointer;
    padding: 10px 15px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background: #f7f8f9;
    border-radius: 8px;
    margin: 0 10px;
    text-align: center;
    margin-bottom: 20px;
    border-color: #e7e9ec;
  }
  .project-list-box_top {
    display: flex;
    justify-content: space-between;
    font-size: 12px;
    align-items: center;
  }
  .project-list-box_top .left {
    opacity: 0.6;
    color: rgba(25, 24, 67, 0.6);
  }
  .project-list-box_top .right {
    color: #509aff;
  }
  .project-list-box_content {
    text-align: center;
    height: 72px;
    padding: 10px 0;
  }
  .project-folder-icon {
    height: 70px;
    width: 70px;
    width: 100%;
    background: #fff;
    border-radius: 4px;
    border-radius: 4px;
    text-align: center;
    line-height: 70px;
  }
  .project-folder-icon > .iconfont {
    font-size: 38px;
    color: #75748e;
  }
  .project-list-box_bottom {
    text-align: center;
    font-size: 14px;
    color: initial;
  }
  .project-folder .badge {
    position: absolute;
    top: 10px;
    right: 10px;
  }
  .main-content-head {
    display: flex;
    justify-content: space-between;
    // height: 54px;
    padding-bottom: 10px;
    width: 100%;
    align-items: center;
    .iconfont {
      font-weight: 500;
    }
  }
}
</style>

